/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * * `indoor` - Indoor
 * * `outdoor` - Outdoor
 * * `side` - Side Stage
 * * `amphitheater` - Amphitheater
 * * `studio` - Studio
 * * `bar_stage` - Bar Stage
 * * `other` - Other
 * @export
 */
export const StageTypeEnum = {
    Indoor: 'indoor',
    Outdoor: 'outdoor',
    Side: 'side',
    Amphitheater: 'amphitheater',
    Studio: 'studio',
    BarStage: 'bar_stage',
    Other: 'other'
} as const;
export type StageTypeEnum = typeof StageTypeEnum[keyof typeof StageTypeEnum];


export function instanceOfStageTypeEnum(value: any): boolean {
    for (const key in StageTypeEnum) {
        if (Object.prototype.hasOwnProperty.call(StageTypeEnum, key)) {
            if (StageTypeEnum[key as keyof typeof StageTypeEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function StageTypeEnumFromJSON(json: any): StageTypeEnum {
    return StageTypeEnumFromJSONTyped(json, false);
}

export function StageTypeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): StageTypeEnum {
    return json as StageTypeEnum;
}

export function StageTypeEnumToJSON(value?: StageTypeEnum | null): any {
    return value as any;
}

export function StageTypeEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): StageTypeEnum {
    return value as StageTypeEnum;
}

